import React from 'react'
import { useState } from 'react';
import { cardapioSections } from './cardapioData';

import {
    AllFullContainer,
    FullContainer,
    FullWrapper,
    WrapperCard,
    TitleSection,
    ImgCard,
    WrapperInfos,
    TitleCard,
    DescripionCard,
    PriceCard,
    ModalCloseButton,
    WarningBox
} from './CardsContentElements'

export default function NewCardModel() {
    const [modalItem, setModalItem] = useState(null);
  return (
    <AllFullContainer>
    {cardapioSections.map(section => (
        <FullContainer id={section.id} key={section.id}>
            <TitleSection>{section.name}</TitleSection>
            <FullWrapper>
                {section.items.map((item, index) => (
                    <WrapperCard onClick={() => setModalItem(item)} key={index}>
                        <ImgCard src={item.foto} alt={item.nome} />
                        <WrapperInfos>
                            <TitleCard>{item.nome}</TitleCard>
                            <DescripionCard style={{ whiteSpace: 'pre-line' }}>
                                {(() => {
                                  const pt = (item.descriçãoPt || '').replace(/<br\s*\/?>/gi, '\n');
                                  return pt.length > 70 ? (
                                    <>
                                      {pt.slice(0, 70)}...
                                      <button
                                        onClick={() => setModalItem(item)}
                                        style={{ color: '#8295a9ff', background: 'none', border: 'none', cursor: 'pointer' }}
                                      >
                                        Ler mais
                                      </button>
                                    </>
                                  ) : pt;
                                })()}
                            </DescripionCard>
                            <PriceCard>{item.price}</PriceCard>
                        </WrapperInfos>
                    </WrapperCard>
                ))}
            </FullWrapper>
            {section.id === 'carne_bovina' && (
                <WarningBox>
                    🕐 Tempo de preparo dos pratos de 30 a 45 minutos.
                </WarningBox>
            )}

            {section.id === 'batidas' && (
                <WarningBox style={{ whiteSpace: 'pre-line' }}>
                    {'🍺 SE BEBER NÃO DIRIJA!\nCobramos taxa de serviço - 10%'}
                </WarningBox>
            )}
            
        </FullContainer>
        
    ))}
        {modalItem && (
        <div style={{
        position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
        background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000
        }}
        onClick={() => setModalItem(null)}
        >
        <div style={{
            width: '80%', background: '#FDDFC7', padding: 30, margin: 10, borderRadius: 10, maxWidth: '420px', maxHeight: '90vh', overflowY: 'auto', display: 'flex', flexDirection: 'column', marginTop: '50px', 
        }}
            onClick={e => e.stopPropagation()}
        >
            <ModalCloseButton onClick={() => setModalItem(null)} >X</ModalCloseButton>
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '20px' }}>
            <img src={modalItem.foto} alt={modalItem.nome} style={{ maxWidth: '72%', borderRadius: '10px', marginBottom: '20px' }} />
            </div>
            <h2 style={{marginBottom: 20}}>{modalItem.nome}</h2>
             <p style={{ fontSize: '0.8rem', whiteSpace: 'pre-line' }}>
              {(modalItem.descriçãoPt || '').replace(/<br\s*\/?>/gi, '\n')}
            </p>
            <p style={{fontSize: '1.2rem', color: '#964F39', fontWeight: 'bold', margin: '20px 0'}}>{modalItem.price}</p>
        </div>
        </div>
    )}
    </AllFullContainer>
    
  )
}
